import { Language } from 'ha/i18n';

const availableLocales = [Language.nl, Language.de];

export default (lang: Language) => availableLocales.includes(lang);
